import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import homeLogo from "../assets/about.png";
import Particle from "../components/Particle";
import Type from "../components/Home/Type";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";

const Home = () => {
  const OpenPDF = () => {
    const url = `https://drive.google.com/file/d/1Q9Y2QSEciBpDwpFRmko_26obU7jL5QcQ/view?usp=share_link`;

    window.open(url, "_blank");
  };
  return (
    <section id="home">
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
              <h1 className="heading-name">
                I'M
                <strong className="main-name" id="user-detail-name">
                  {" "}
                  Prabhat kumar{" "}
                </strong>
              </h1>
              <div style={{ marginTop: "20px" }}>
                <h4 className="heading-fullStack">
                  Full Stack
                  <strong className="main-name"> Web Developer </strong>
                </h4>
                <h4 className="heading-fullStack">
                  Passinate about doing things creatively.
                </h4>
              </div>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
              <a id="resume-link-2">
                <Button
                  style={{ marginLeft: "42px" }}
                  onClick={OpenPDF}
                  id="resume-button-2"
                  href="Prabhat-Kumar-Resume.pdf"
                  download="Prabhat-Kumar-Resume.pdf"
                >
                  Resume
                </Button>
              </a>

              <Row>
                <div style={{width: "100%",  display: "flex",justifyContent: "center",marginTop: "15px"}}>
                  <ul className="home-about-social-links">
                    <li className="social-icons">
                      <a
                        href="https://github.com/Prabhat-kumar-11"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour  home-social-icons"
                        aria-label="github"
                      >
                        <AiFillGithub />
                      </a>
                    </li>
                    <li className="social-icons">
                      <a
                        href="mailto:prabhssgg3@gmail.com"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour  home-social-icons"
                        aria-label="github"
                      >
                        <MdEmail />
                      </a>
                    </li>
                    {/* <li className="social-icons"></li> */}
                    <li className="social-icons">
                      <a
                        href="https://www.linkedin.com/in/prabhatkumar511/"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour  home-social-icons"
                        aria-label="linkedin"
                      >
                        <FaLinkedinIn />
                      </a>
                    </li>
                    <li className="social-icons">
                      <a
                        href="https://www.instagram.com/morningstar11._"
                        target="_blank"
                        rel="noreferrer"
                        className="icon-colour home-social-icons"
                        aria-label="instagram"
                      >
                        <AiFillInstagram />
                      </a>
                    </li>
                  </ul>
                </div>
              </Row>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
};

export default Home;
